import script from "./ParecerPrimeiroTri.vue?vue&type=script&setup=true&lang=js"
export * from "./ParecerPrimeiroTri.vue?vue&type=script&setup=true&lang=js"

import "./ParecerPrimeiroTri.vue?vue&type=style&index=0&id=5b3f2a81&lang=css"

const __exports__ = script;

export default __exports__